import { Component, Input } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: 'app-confirm-dialog',
  template: `
      <nb-card>
        <nb-card-header>{{ title }}</nb-card-header>
        <div class="d-flex justify-content-center align-items-center text-center" style="min-height: 150px;">
          <nb-card-body>{{ message }}</nb-card-body>
        </div>
        <nb-card-footer class="d-flex justify-content-between">
          <button nbButton (click)="cancel()">{{ cancelLabel }}</button>
          <button nbButton status="primary" (click)="confirm()">{{ confirmLabel }}</button>
        </nb-card-footer>
      </nb-card>
    `,
    styles: [`
      nb-card {
        width: 400px;
        max-width: 90%;
      }
    `]
})
export class ConfirmDialogComponent {
  @Input() title: string = 'Confirmación';
  @Input() message: string = '¿Estás seguro?';
  @Input() confirmLabel: string = 'Sí';
  @Input() cancelLabel: string = 'No';

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) { }

  confirm() {
    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }
}
